<template>
  <div class="mall-order-status-steps">
    <template v-for="(step, index) in steps">
      <img
        v-if="index > 0"
        :key="step.key + '-caret'"
        class="mall-order-status-steps__caret"
        src="@/assets/mall/icn_caret_right_gray.svg"
        alt=""
      />
      <div
        :key="step.key"
        class="mall-order-status-steps__step"
        :class="{ 'mall-order-status-steps__step--active': step.count > 0 }"
      >
        <span class="mall-order-status-steps__label">{{ step.label }}</span>
        <span class="mall-order-status-steps__count">{{ step.count }}</span>
      </div>
    </template>
  </div>
</template>

<script>
// 배송 단계별 상품 수 (상품이 있는 단계는 강조)
export default {
  name: 'MallOrderStatusSteps',
  props: {
    // [{ key, label, count }]
    steps: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-order-status-steps {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-top: 1px solid #E5E8EB;
  border-bottom: 1px solid #E5E8EB;
  background: #F2F4F6;
}

.mall-order-status-steps__caret {
  display: block;
  flex-shrink: 0;
}

.mall-order-status-steps__step {
  display: flex;
  width: 70px;
  flex-shrink: 0;
  flex-direction: column;
  gap: 4px;
  color: #8B95A1;
  font-family: Pretendard;
  font-weight: var(--font-weight-medium);
  text-align: center;
}

.mall-order-status-steps__step--active {
  color: #0096FF;
}

/* 줄 높이(150%)는 글자 크기가 다른 항목마다 따로 지정 */
.mall-order-status-steps__label {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-order-status-steps__count {
  font-size: var(--font-size-md);
  line-height: var(--line-height-normal);
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderStatusSteps.vue